import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ConfigurationService } from '../../services/configuration.service';
import { ToastEnum } from '../../enums/toast.enum';

@Injectable({
  providedIn: 'root',
})
export class CustomerAllContragentsReportReadyEventHandler {
  constructor(
    private _configService: ConfigurationService,
    private _messageService: MessageService
  ) {}

  public async handle(eventData): Promise<void> {
    if (eventData.showPopup) {
      eventData.downloadUrl = this._configService.configuration.links.fileDownloadUrl.replace(
        '{0}',
        eventData.fileGuid
      );
      this._messageService.add({
        sticky: false,
        life: 30000,
        summary: 'Завершено формирование отчёта о проверке всех участников электронной процедуры ',
        detail: (eventData.notificationNumber ? eventData.notificationNumber : '') + '.',
        data: { ...eventData, typeEnum: ToastEnum.archiveToast },
      });
    }
  }
}
